// 「🏠 回到主頁」:連回公司內網入口網站。全公司內網網站統一規格(文字、顏色、圓角一致),
// 方便同事辨認。同分頁開啟(不用 target=_blank)。
//   - 預設:放在側邊欄最上方(登入後所有頁面)
//   - fixed:固定在畫面左下角(給沒有側邊欄的登入頁)
// 樣式依統一規格:白底、細框線 #E8E2D8、文字 #3C3C3C、圓角 999px、內距 8px 14px、字級 14px、hover 框線品牌紅 #C6232C。
export const PORTAL_URL = "http://192.168.100.205/";

export default function HomePortalLink({ fixed = false }: { fixed?: boolean }) {
  return (
    <a
      href={PORTAL_URL}
      className={
        "inline-flex items-center gap-1 rounded-full border border-[#E8E2D8] bg-white px-[14px] py-2 text-[14px] leading-none text-[#3C3C3C] no-underline transition-colors hover:border-[#C6232C]" +
        (fixed ? " fixed bottom-4 left-4 z-50 shadow-sm" : "")
      }
    >
      🏠 回到主頁
    </a>
  );
}
